export const setAuth = (token, user, accounts) => {
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(user));
  localStorage.setItem('accounts', JSON.stringify(accounts || []));
  
  // Auto-select account if only one exists
  if (accounts && accounts.length === 1) {
    localStorage.setItem('current_account', JSON.stringify(accounts[0]));
  }
};

export const getAuth = () => {
  const token = localStorage.getItem('token');
  const userStr = localStorage.getItem('user');
  const accountsStr = localStorage.getItem('accounts');
  const user = userStr ? JSON.parse(userStr) : null;
  const accounts = accountsStr ? JSON.parse(accountsStr) : [];
  return { token, user, accounts };
};

export const getCurrentAccount = () => {
  const accountStr = localStorage.getItem('current_account');
  return accountStr ? JSON.parse(accountStr) : null;
};

export const setCurrentAccount = (account) => {
  localStorage.setItem('current_account', JSON.stringify(account));
};

export const clearAuth = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('accounts');
  localStorage.removeItem('current_account');
};

export const isAuthenticated = () => {
  return !!localStorage.getItem('token');
};

export const isSuperAdmin = () => {
  const { user } = getAuth();
  return user?.is_super_admin || false;
};

export const isSuperPfAdmin = () => {
  const { user } = getAuth();
  return user?.is_super_pf_admin || false;
};
